var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDeliveryDetailsSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0406 7.19L12.0006 12.42L2.96063 7.19C3.36063 6.45 3.94063 5.8 4.59063 5.44L9.93063 2.48C11.0706 1.84 12.9306 1.84 14.0706 2.48L19.4106 5.44C20.0606 5.8 20.6406 6.45 21.0406 7.19Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.0006 12.42V22C11.2506 22 10.5006 21.84 9.93062 21.52L4.59063 18.56C3.38063 17.89 2.39062 16.21 2.39062 14.83V9.17C2.39062 8.53 2.61062 7.83 2.96062 7.19L12.0006 12.42Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6106 9.17V14.83C21.6106 16.21 20.6206 17.89 19.4106 18.56L14.0706 21.52C13.5006 21.84 12.7506 22 12.0006 22V12.42L21.0406 7.19C21.3906 7.83 21.6106 8.53 21.6106 9.17Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDeliveryDetailsSectionIcon);
export default __webpack_public_path__ + "f77c76550327727b6e63a9d6ffca81ed.svg";
export { ForwardRef as ReactComponent };